import React, { useEffect, useMemo, useState } from 'react'

import { RunContentProps } from './RunContent.types'
import dayjs from 'dayjs'

import ParamCard, { ParamCardProps } from './Cards/ParamCard'
import FileCard, { FileCardProps } from './Cards/FileCard'
import FolderCard, { FolderCardProps } from './Cards/FolderCard'

import './RunContent.scss'
import { usePollinationPanel } from '../hooks/usePollinationPanel'
import { useRuns } from '../hooks'
import { List } from 'react-bootstrap-icons'

export const RunContent: React.FC<RunContentProps> = ({
  inputData,
  projectOwner,
  projectName,
  run,
  client,
  title,
  style,
  getFileCard,
  getFolderCard,
  isCloud=true,
  isOpen=true
}) => {
  const { getTrigger } = useRuns(client)
  const [currData, setCurrData] = useState<any[]>([])
  const { fileExplorer } = usePollinationPanel()

  const [currParams, setCurrParams] = useState<ParamCardProps[]>([])
  const [currFiles, setCurrFiles] = useState<FileCardProps[]>([])
  const [currFolders, setCurrFolders] = useState<FolderCardProps[]>([])
  const [open, setOpen] = useState<boolean>(isOpen)
  
  const trigger = useMemo(() => isCloud ? getTrigger(run) : false, [run, isCloud])

  useEffect(() => setCurrData(inputData), [inputData])

  useEffect(() => {
    if (!currData || currData.length == 0) return

    let params = [] as ParamCardProps[]
    let files = [] as FileCardProps[]
    let folders = [] as FolderCardProps[]

    currData.forEach((i) => {
      switch (i.type) {
        case 'StepFileInput':
          files.push({ run: run, label: i.name, 
            path: i.source?.path, description: i.description })
          break
        case 'StepFileOutput':
          const filePath = trigger
            ? `outputs/${i.name}/${run.id}.zip`
            : i.source?.path
          files.push({ run: run, label: i.name, 
            path: filePath, description: i.description })
          break
        case 'StepFolderInput':
          folders.push({ label: i.name, path: i.source?.path,
            description: i.description })
          break
        case 'StepFolderOutput':
          const folderPath = trigger
            ? `outputs/${i.name}`
            : i.source?.path
          folders.push({ label: i.name, path: folderPath,
            description: i.description })
          break
        default:
          params.push({ label: i.name, value: i.value, 
            type: i.type, description: i.description })
          break
      }
    })

    setCurrParams(params)
    setCurrFiles(files)
    setCurrFolders(folders)
  }, [currData])

  // const checkIfValidUUID = (str: string): boolean => {
  //   const regexExp = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/gi
  //   return regexExp.test(str)
  // }

  // const isCloud = useMemo(() => checkIfValidUUID(runId), [runId])

  /**
   * Click event handler of the file card
   * @param card File card props
   */
  const onFileClicked = (card: FileCardProps) => {
      getFileCard(card)
  }


  /**
   * Click event handler of the folder card
   * @param card Folder card props
   */
  const onFolderClicked = (card: FolderCardProps) => {
    getFolderCard(card)
    if (!isCloud) {
      fileExplorer(card.path)
    }
  }

  return <div className='cards-container' style={{ ...style }}>
    <button
      style={{ all: 'unset', 
        width: '100%',
        cursor: 'pointer' }}
      onClick={(e: any) => {
        e.stopPropagation()
        setOpen(prev => !prev)
      }}>
      <h5 className='cards-container-title'
        style={open 
          ? { display: 'inline-block', 
            paddingBottom: '0px' }
          : { display: 'inline-block'}}
      >{title || 'Something'}</h5>
      <List size={18} style={{ float: 'right', margin: '10px 15px'}}
        title='View more'/>
    </button>
    {open && currFiles.length > 0 && projectOwner && projectName && client && run && <div style={{ padding: '20px' }}>
      <div className='cards'>
        {currFiles.map(({label, path, description}, index) => {
          return <FileCard 
            projectOwner={projectOwner}
            projectName={projectName}
            run={run}
            client={client}
            key={`filecard-${index}`}
            label={label} 
            path={path} 
            description={description} 
            onClicked={onFileClicked}
            isCloud={isCloud}
            />
        })}
      </div>
    </div>}

    {open && currFolders.length > 0 && <div style={{ padding: '20px' }}>
      <div className='cards'>
        {currFolders.map(({label, path, description}, index) => {
          return <FolderCard 
            key={`foldercard-${index}`}
            label={label} 
            path={path} 
            description={description} 
            onClicked={onFolderClicked}
            />
        })}
      </div>
    </div>}

    {open && currParams.length > 0 && <div style={{ padding: '20px' }}>
      <div className='cards'>
        {currParams && currParams.map(({ label, value, type, description}, index) => {
          return <ParamCard 
            key={`parmcard-${index}`} 
            label={label} 
            value={value} 
            type={type} 
            description={description} />}
          )}
      </div>
    </div>}
  </div>
}

export default RunContent

